import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const ArrowLeft = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M2.5 10.01c0 .546.224 1.068.62 1.444l7.97 7.58a1.995 1.995 0 0 0 2.75-2.89l-6.453-6.137 6.454-6.152A1.995 1.995 0 0 0 11.088.968l-7.97 7.597A2 2 0 0 0 2.5 10.01" }) }));
});
ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;
//# sourceMappingURL=ArrowLeft.js.map